export const iconFontAwesomeEnergyArrowUpFromGroundWater = (
	<i className="fa-solid fa-arrow-up-from-ground-water"></i>
);
